import React from 'react';
import Vendor from 'data/Vendor';
import OrdersList from 'components/Orders/OrderList/OrdersList';
import FeatureFlag from 'data/FeatureFlag';
import { BusinessUnit } from 'data/BusinessUnit';

interface Props {
  id: number;
  companyId: string;
  featureFlags: FeatureFlag,
  selectedVendor?: Vendor;
  selectedBusinessUnit?: BusinessUnit;
};

const OrderHistoryTab = ({
  id,
  companyId,
  selectedVendor,
  selectedBusinessUnit,
  featureFlags
}: Props) => {
  return (
    <OrdersList
      selectedBusinessUnit={selectedBusinessUnit}
      selectedVendor={selectedVendor}
      shouldRedirect={false}
      headingText="Past orders"
      pagePadding="0"
      navigateBackUrl={`/companies/company-details/${id}`}
      companyId={companyId}
      featureFlags={featureFlags}
    />
  );
};

export default OrderHistoryTab;
